module.exports = __webpack_public_path__ + "img/facebook.61a71d18.png";